class CommandTriggerEvent {
    constructor() {
        this.target = null;
        this.initiatorEvent = null;
        this.data = null;
    }

    setTarget(newTarget) {
        this.target = newTarget;
    }

    setInitiatorEvent(newInitiatorEvent) {
        this.initiatorEvent = newInitiatorEvent;
    }

    setData(newData) {
        this.data = newData;
    }

    copy() {
        const eventCopy = new CommandTriggerEvent();

        eventCopy.target = this.target;
        eventCopy.initiatorEvent = this.initiatorEvent;
        eventCopy.data = this.data;

        return eventCopy;
    }
}

export default CommandTriggerEvent;
